import { FC } from "react";

import { Hero } from "components/Hero";
import { SectionHeader } from "components/Section/SectionHeader";
import { SectionWithImages } from "components/Section/SectionWithImages";
import { SectionWithGridList } from "components/Section/SectionWithGridList";
import { Team } from "components/Team";
import { ContactSection } from "components/Contact";

const features = [
	{
		name: "Development Economics & Policy",
		description:
			"We advise on Economic Formulation issues and Research with regards to Budgeting, Fiscal Policy, and Monetary Policy and how these policies impact on Economic Growth and Employment.",
	},
	{
		name: "Fiscal Sustainability & Advisory",
		description:
			"Our firm has a model that interrogates states financial practices and issues with respect to the following: Fiscal Sustainability Framework, Debt Management including debt sustainability analysis and more.",
	},
	{
		name: "Tax Advisory & Consulting",
		description:
			"We offer Tax Advisory services to clients regarding their tax obligations to various governments: federal, state and local governments.",
	},
	{
		name: "Business Solvency & Turnarounds",
		description:
			"We use analysis and planning to save troubled companies and returns them to solvency, and to identify the reasons for failing performance (or decreasing presence and position) in the market, and rectify them.",
	},
	{
		name: "Financial Advisory",
		description:
			"We render financial services to various individuals and corporate entities. Our services in this area include: Financial modeling, Writing books of account for clients and preparing final accounts, Sourcing private equity capital.",
	},
	{
		name: "Project Management & Oversight",
		description:
			"Leveraging on our capability to serve as project management advisors in turnkey projects for both corporate and public sector organizations.",
	},
];

const people = [
	{
		name: "Olufemi Awoyemi",
		role: "Chairman",
		imageUrl:
			"https://res.cloudinary.com/dp8g2jwak/image/upload/v1662190070/view-limited/team/olufemi-awoyemi_qtxmuf.png",
		bio: "Olufemi Awoyemi, Chairman of View Limited (a knowledge-based audit, assurance and advisory services firm), is a member of the National Institute and a Fellow of The Institute of Chartered Accountants of Nigeria (ICAN)",
		twitterUrl: "https://twitter.com/OlufemiAwoyemi",
		linkedinUrl: "#",
	},
	{
		name: "Jojo Dawodu",
		role: "Partner",
		imageUrl:
			"https://res.cloudinary.com/dp8g2jwak/image/upload/v1662191282/view-limited/team/jojo-dawodu_fnc5yo.jpg",
		bio: "Mr. Jojo Dawodu is a graduate of Economics/Urban and Regional Planning from the Florida State University, USA with a rich and varied work experience from marketing of fast moving consumer goods to project management.",
		twitterUrl: "#",
		linkedinUrl: "#",
	},
];

export const Home: FC = () => {
	return (
		<>
			<Hero />
			<div className='py-20'>
				<SectionHeader title='About Us'>
					<p className='mb-4 font-semibold'>
						We are a multidisciplinary consulting firm, founded on the 16th day
						of February 1993 as a competitiveness optimization firm focused on
						thought-led developmental economics, fiscal sustainability and
						management advisory services.
					</p>
					<p>
						Our strength lies in our experience, professional expertise of our
						partner network, ethical approach and quality of service delivery.
					</p>
				</SectionHeader>
			</div>
			<div className='relative overflow-hidden bg-white pt-16 pb-32'>
				<SectionWithImages
					description='We carry our Management, Systems Investigative Audits and any other special Audit as prescribed by our clients. Our strategy in executing the audit is a systematic approach to audit work, based on the operation and the records available in the client’s organization.'
					imageAlt='A corporate HQ as seen from the bottom up'
					imageURL='https://res.cloudinary.com/dp8g2jwak/image/upload/v1662155494/view-limited/hero/audit_assurance_qcrtiu.jpg'
					isFirst
					title='Audit Assurance'
				/>
				<SectionWithImages
					description='Our company offers receivership management liquidation services for companies that the financial and going concern constraints. Our approach is to strive to restructure and reposition the organization as a visible entity or at least maximize the returns on sale of assets in setting as many creditors as possible.'
					imageAlt="An unattended laption with the words 'Audit Assurance' displaying on the screen"
					imageURL='https://res.cloudinary.com/dp8g2jwak/image/upload/v1662155432/view-limited/hero/receivership_xuoawu.jpg'
					isBelow
					isFirst={false}
					title='Receivership Management, Liquidation & Debt Recovery'
				/>
				<SectionWithImages
					description='On the instruction of our clients, we carry out forensic audit to uncover frauds and irregularities in a business operation especially in the accounting department.'
					imageAlt="A person typing into a laptop with the words 'Forensic Investigation and Audit' printed on the screen"
					imageURL='https://res.cloudinary.com/dp8g2jwak/image/upload/v1662156574/view-limited/hero/forensic_investigation_bbb7kp.jpg'
					isBelow
					isFirst
					title='Special Investigations & Due Diligence'
				/>
			</div>
			<div className='pt-20'>
				<SectionWithGridList list={features} />
			</div>
			<div className='bg-gray-100 py-20'>
				<Team people={people} />
			</div>
			<div className='bg-gray-800 py-20'>
				<ContactSection
					email='project@viewlimited.com'
					phone='+234 70 8399 9377'
				/>
			</div>
		</>
	);
};
